if (!customElements.get('image-grid')) {
  class ImageGrid extends HTMLElement {
    constructor () {
      super();
      this.slider = this.querySelector('.image-grid--items');
      this.slides = this.querySelectorAll('.image-grid--item');
      this.actionPrev = this.querySelector('.image-grid--nav-prev');
      this.actionNext = this.querySelector('.image-grid--nav-next');
      this.step = 2;
      this.minSlide = 0;
      this.maxSlide = this.slides.length - 1;
      // this.maxSlide = this.slides.length - this.step;
      // this.maxSlide = Math.ceil(this.slides.length / 2) * 2;
      this.index = this.minSlide;
      this.sliderWidth = this.slides[0].offsetWidth;
    }

    connectedCallback() {
      this.actionNext.addEventListener('click', () => {
        this.index = this.index + this.step;
        this.updateSlider();
      });
      this.actionPrev.addEventListener('click', () => {
        this.index = this.index - this.step;
        this.updateSlider();
      });

      window.addEventListener('resize', () => {
        this.sliderWidth = this.slides[0].offsetWidth;
      });
    }

    updateSlider() {
      if (this.index < this.minSlide) this.index = this.minSlide;
      if (this.index > this.maxSlide) this.index = this.maxSlide;

      console.log(this.index, this.sliderWidth);

      this.style.setProperty('--position', `translateX(${0 - (this.index * this.sliderWidth)}px)`);
    }
  }
  customElements.define('image-grid', ImageGrid);
}